export default __webpack_public_path__ + "static/media/close.2ced0f9b.svg";